import { Link } from "gatsby"
import React from "react"

export const ConstructionMethodsVertical = ({
  construction_method_blogposts,
  ressort,
}) => {
  return (
    <div data-nosnippet className="py-4 my-3 most-read-wrapper pl-2">
      <p className="has-text-weight-bold mb-3 mt-0 has-text-mitternachtsblau">
        Hintergrundwissen
      </p>
      {construction_method_blogposts?.map(({ slugline, title }, index) => {
        const article_link = `/fachzeitschriften/${ressort}/bauverfahren/${slugline}`
        return (
          <Link to={article_link} key={`related-${index}`}>
            <p
              className={`has-text-${ressort} mb-0 is-clipped`}
              style={{
                minHeight: "1.75rem",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              Bauverfahren
            </p>

            <p
              className={`has-text-weight-bold has-text-mitternachtsblau mb-0`}
            >
              {title}
            </p>
          </Link>
        )
      })}
    </div>
  )
}
